import { Auth } from "aws-amplify";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { clientConfig } from "../../awsClientConfig";
import Loading from "../../Common/Loading";
import { userProfileData } from "../../Common/profileInfo";
import { InitiateEnrollment } from "../../queries/InitiateEnrollment";
import { Provider } from "./change-plan-enrolment-context";
import useFeatureStore from "../../store/FeatureStore";
import ProtectionPlanEligibility  from "./protection-plan-eligibility";
import ProtectionPlanPrice from "./protection-plan-price";
import ClientProfileInformation from "./client-profile-information";
import ClientServiceAgreementForm from "./client-service-agreement-form";
import SignatureForm from "./signature-form";
import BillingInformationForm from "./billing-information-form";
import PaymentDetailsForm from "./payment-details-form";
import EnrollmentCompletedForm from "./enrollment-completed-form";
import { paths } from "../../paths";
import Footer from "../footer";

export const motionContainer = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.3 } },
  exit: { opacity: 0, transition: { duration: 0.2 } }
};

const renderStep = (step: number) => {
  switch (step) {
    case 1:
        return <ProtectionPlanEligibility />;
    case 2:
      return <ProtectionPlanPrice />;
    case 3:
        return <ClientProfileInformation />;
    case 4:
      return <ClientServiceAgreementForm />;
    case 5:
      return <SignatureForm />;
    case 6:
      return <BillingInformationForm  />;
    case 7:
      return <PaymentDetailsForm />;
    case 8:
      return <EnrollmentCompletedForm />;
    case 9:
      return <Loading />;
    default:
      return null;
  }
};

const ChangePlanEnrolmentForm = () => {
  const [enrollmentId, setEnrollmentId] = useState("");
  const [currentStep, setCurrentStep] = useState(9);
  const [nextFormId, setNextFormId] = useState("");
  const [s3key, setS3Key] = useState("");
  const [s3Bucket, setS3Bucket] = useState("");
  const [finalPlan, SetFinalPlan] = useState();
  const [recommandedPlan, setRecommandedPlan] = useState();
  const [unavailableProtectionPlan, setUnavailableProtectionPlan] = useState();
  const [billingAddress, setBillingAddress] = useState();
  const [promoCode, setPromoCode] = useState<string | undefined>();
  const [promotionCodeType, setPromotionCodeType] = useState<string | undefined>();
  const { featureFlags } = useFeatureStore();
  const { state } = useLocation();
  const [sameAsMailing, setSameAsMailing] = useState<boolean>(false);

  const client = new clientConfig();
  const navigate = useNavigate();
  useEffect(() => {
    InitiateChangePlanEnrollment();
  }, []);

  const InitiateChangePlanEnrollment = async () => {
    await Auth.currentAuthenticatedUser({ bypassCache: true });
    const profileId = await userProfileData();
    const variables = {
      profileId: profileId,
      type: "ProtectionPlanChange",
    };
    client
      .mutate({ mutation: InitiateEnrollment, variables: variables })
      .then((res: any) => {
        if (res.data.InitiateEnrollment.Id) {
          setEnrollmentId(res.data.InitiateEnrollment.Id);
          setNextFormId(res.data.InitiateEnrollment.NextForm?.Id);
          setS3Bucket(res.data.InitiateEnrollment.NextForm?.S3Bucket);
          setS3Key(res.data.InitiateEnrollment.NextForm?.S3Key);
          setRecommandedPlan(
            res.data.InitiateEnrollment?.RecommendedProtectionPlan
          );
         setUnavailableProtectionPlan(
          res.data.InitiateEnrollment?.UnavailableProtectionPlan
         )
          SetFinalPlan(res.data.InitiateEnrollment?.ProtectionPlan);
          NextEnrollmentAction(
            res.data.InitiateEnrollment?.NextEnrollmentAction
          );
        }
      })
      .catch((error: any) => {
        console.log("error", error);
        navigate(paths.dashboard.taxShield.enrollment);
        setCurrentStep(1);
      });
  };

  const NextEnrollmentAction = (nextAction: string) => {
    if (nextAction === "AnswerQualifyingQuestions") {
      setCurrentStep(1);
    }
    if (nextAction === "SelectProtectionPlan") {
      if(state && state.from && state.from === 'taxIdTheftAlert'){
        setCurrentStep(2);
      }else{
        setCurrentStep(1);
      }
    }
    if (nextAction === "CompleteInformation") {
      setCurrentStep(3);
    }
    if (nextAction === "CompleteServiceAgreement") {
      setCurrentStep(4);
    }
    if (nextAction === "CompletePayment") {
      setCurrentStep(6);
    }
    if(!nextAction){
      state?.from === 'changePlan' ? setCurrentStep(1) : navigate(paths.dashboard.overview);
    }
  };

  const next = () => {
    /*if (currentStep === 10) {
      setCurrentStep(0);
      return;
    }*/
    setCurrentStep(currentStep + 1);
  };

  const previous = () => {
      setCurrentStep(currentStep - 1);
  };

  const gotoStep = (step: number) => {
    setCurrentStep(step);
  };


  return (
    <Provider
      value={{
        next,
        previous,
        gotoStep,
        enrollmentId,
        setEnrollmentId,
        nextFormId,
        setNextFormId,
        s3key,
        setS3Key,
        s3Bucket,
        setS3Bucket,
        finalPlan,
        SetFinalPlan,
        recommandedPlan,
        setRecommandedPlan,
        unavailableProtectionPlan,
        setUnavailableProtectionPlan,
        billingAddress,
        setBillingAddress,
        promoCode,
        setPromoCode,
        promotionCodeType,
        setPromotionCodeType,
        sameAsMailing,
        setSameAsMailing
      }}
    >
      <div className="page-container">
      {renderStep(currentStep)}
      </div>
      <Footer/>
    </Provider>
  );
};
export default ChangePlanEnrolmentForm;
